import React from "react";
/** Services Import */
import Global from "../../Services/Common/Global";
import Commons from "../../Services/Common/Common";
import Dialog from "../../Services/Common/Dialog";
import IndexedDb from "../../Services/IndexedDb/IndexedDb";
import Progressbar from "../../Components/Progressbar";

/** Components Import */
import SM10060View from "../../Views/Sales/SM10060";
import SM10061View from "../../Views/Sales/SM10061";
import Snackbar from "../../Components/Snackbar";

function SM10060(props) {
  const [snackbars, setSnackbars] = React.useState({
    toggle: false,
    type: "",
    message: "",
  });
  const [lanData, setLanData] = React.useState([]);
  const [rowData, setRowData] = React.useState([]);
  const [rowData1, setRowData1] = React.useState([]);
  const [rowData2, setRowData2] = React.useState([]);
  const [rowData3, setRowData3] = React.useState([]);
  const [progress, setProgressbar] = React.useState(false);
  const [saveSoDueDt, setSaveSoDueDt] = React.useState("");
  const [selectedRowData, setSelectedRowData] = React.useState([]);
  const today = new Date();
  const monthAgo = new Date(today);
  const [bomDataList, setBomDataList] = React.useState([
    {
      value: "",
      name: "",
    },
  ]);
  const [processCdCheck, setProcessCdCheck] = React.useState(false);

  const [bomData, setBomData] = React.useState("");
  const [delivOrderData, setDelivOrderData] = React.useState([]);
  const [tabToggle, setTabToggle] = React.useState(false);
  const [inputs, setInputs] = React.useState({
    //자재투입정보
    bomSoQty: 0,
    bomOrderQty: 0,
    bomWorkQty: 0,
    bomItemList: [
      {
        value: "",
        name: "",
      },
    ],
    bomItemNm: "", //자재품명
    SoQty: 0, //주문수량
    OrderQty: 0, //지시수량
    WorkQty: 0, //생산수량
    backQty: 0,
    delivQty: 0,
    delivOrderQty: 0,

    //생산정보
    workStartDt: "", //시작일
    workEndDt: "", //종료일

    //작업지시정보
    custNm: "", //거래처
    itemNm: "", //제품품명
    itemCd: "", //제품품명
    itemType: "", //품목타입
    itemStd: "",
    itemUnit: "",
    soNo: "",
    barcodeValue: "",
    delivNo: "", //출하번호
    delivOrderNo: "", //출하지시번호
  });
  let bomItemLists = [];

  React.useEffect(() => {
    window.addEventListener("error", (e) => {
      if (e.message === "ResizeObserver loop limit exceeded") {
        const resizeObserverErrDiv = document.getElementById(
          "webpack-dev-server-client- overlay-div"
        );
        const resizeObserverErr = document.getElementById(
          "webpack-dev-server-client-overlay"
        );
        if (resizeObserverErr) {
          resizeObserverErr.setAttribute("style", "display: none");
        }
        if (resizeObserverErrDiv) {
          resizeObserverErrDiv.setAttribute("style", "display: none");
        }
      }
    });
    SearchLogic();
  }, []);

  const SearchLogic = async (_woNo) => {
    let getLanData = [];

    try {
      await IndexedDb.GetAllDb("LanguageList").then((result) => {
        if (result.length > 0) {
          getLanData = result.filter((f) => f.lanType !== "MENU");
        }
      });
      setLanData(getLanData);
    } catch (e) {
      if (e.response.status === 401) {
        setSnackbars({
          toggle: true,
          type: "error",
          message: "로그인 정보가 만료되었습니다.",
        });
      } else {
        setSnackbars({
          toggle: true,
          type: "error",
          message: e.message,
        });
      }
    } finally {
      Dialog.ProgressBar(false);
    }
  };

  const Init = async (_type = null) => {
    // Dialog.ProgressBar(true);
    setProgressbar(true);

    let getLanData = [];
    let getRowData = [];
    let getComboData = [];
    try {
      setInputs({
        ...inputs,
        delivOrderNo: "",
        custCd: "",
        custNm: "",
      });
      await IndexedDb.GetAllDb("LanguageList").then((result) => {
        if (result.length > 0) {
          getLanData = result.filter((f) => f.lanType !== "MENU");
        }
      });
      setLanData(getLanData);

      await Commons.Axios(
        "get",
        Global.serverUrls.useUrl +
          Global.urls.logic.Sales.SM10040.GetSalesDelivOrdersPDA,
        {
          startDate: new Date(today.setMonth(today.getMonth() - 1)),
          endDate: new Date(),
          delivOrderNo: inputs.searchInput ? inputs.searchInput : "string",
        }
      ).then((result) => {
        let data = result.data;
        if (data === "데이터가 없습니다.") {
          if (lanData.length != 0) {
            setSnackbars({
              toggle: true,
              type: "info",
              message: lanData.filter(
                (f) => f.lanId === "Snack_NullData" && f.lanType === "SNACK"
              )[0].lanName,
            });
          }
        } else if (data.type === "Error") {
          if (lanData.length != 0) {
            setSnackbars({
              toggle: true,
              type: "info",
              message: lanData.filter(
                (f) => f.lanId === "Snack_NullData" && f.lanType === "SNACK"
              )[0].lanName,
            });
          }
        } else {
          if (_type == 3) {
            for (let i = 0; i < data.length; i++) {
              if (data[i].stusCd == "3") {
                getRowData.push({
                  soDueDt: data[i].soDueDt
                    ? Commons.DateFormating(data[i].soDueDt.toString(), 2)
                    : "",
                  itemNm: data[i].itemNm,
                  soNo: data[i].soNo,
                  itemCd: data[i].itemCd,
                  custNm: data[i].custNm,
                  delivOrderDt: data[i].delivOrderDt
                    ? Commons.DateFormating(data[i].delivOrderDt.toString(), 2)
                    : "",
                  delivOrderNo: data[i].delivOrderNo,
                  remark: data[i].remark,
                  delivOrderQty: data[i].delivOrderQty,
                  // lotNo: data[i].lotNo,
                });
              }
            }
          }
        }
        setRowData(Commons.InsertNumber(getRowData));
      });
    } catch (e) {
      if (e.response.status === 401) {
        setSnackbars({
          toggle: true,
          type: "error",
          message: "로그인 정보가 만료되었습니다.",
        });
      } else {
        setSnackbars({
          toggle: true,
          type: "error",
          message: e.message,
        });
      }
    } finally {
      // Dialog.ProgressBar(false);
      setProgressbar(false);
    }
  };
  //출하취소 탭 출하번호 조회
  const GetSalesDelivOrderItems = async (_type = null) => {
    let getLanData = [];
    let getRowData = [];
    let getComboData = [];
    try {
      await IndexedDb.GetAllDb("LanguageList").then((result) => {
        if (result.length > 0) {
          getLanData = result.filter((f) => f.lanType !== "MENU");
        }
      });
      setLanData(getLanData);

      await Commons.Axios(
        "get",
        Global.serverUrls.useUrl +
          Global.urls.logic.Sales.SM10040.GetSalesDelivOrderItems,
        {
          delivOrderNo: inputs.searchInput ? inputs.searchInput : "string",
        }
      ).then((result) => {
        let data = result.data;
        console.log(data);
        if (data === "데이터가 없습니다.") {
          setSnackbars({
            toggle: true,
            type: "info",
            message: lanData.filter(
              (f) => f.lanId === "Snack_NullData" && f.lanType === "SNACK"
            )[0].lanName,
          });
        }
        for (let i = 0; i < data.length; i++) {
          getRowData.push({
            delivNo: data[i].delivNo,
            delivDt: data[i].delivDt,
            delivOrderQty: data[i].delivOrderQty,
            delivQty: data[i].delivQty,
            itemCd: data[i].itemCd,
            itemNm: data[i].itemNm,
            remark: data[i].remark,
          });
        }
        setRowData(Commons.InsertNumber(getRowData));
      });
    } catch (e) {
      if (e.response.status === 401) {
        setSnackbars({
          toggle: true,
          type: "error",
          message: "로그인 정보가 만료되었습니다.",
        });
      } else {
        setSnackbars({
          toggle: true,
          type: "error",
          message: e.message,
        });
      }
    } finally {
      // Dialog.ProgressBar(false);
      setProgressbar(false);
    }
  };
  const GetDelivOrderDtls = async (_delivOrderNo) => {
    // Dialog.ProgressBar(true);
    setProgressbar(true);

    let getRowData = [];
    try {
      await Commons.Axios(
        "get",
        Global.serverUrls.useUrl +
          Global.urls.logic.Sales.SM10040.GetSalesDelivOrderItems,
        {
          delivOrderNo: _delivOrderNo,
        }
      ).then((result) => {
        let data = result.data;
        if (data === "데이터가 없습니다.") {
          if (lanData.length != 0) {
            setSnackbars({
              toggle: true,
              type: "info",
              message: lanData.filter(
                (f) => f.lanId === "Snack_NullData" && f.lanType === "SNACK"
              )[0].lanName,
            });
          }
          setRowData1([]);
        } else if (data.type === "Error") {
          if (lanData.length != 0) {
            setSnackbars({
              toggle: true,
              type: "info",
              message: lanData.filter(
                (f) => f.lanId === "Snack_NullData" && f.lanType === "SNACK"
              )[0].lanName,
            });
          }
        } else {
          setSnackbars({
            toggle: true,
            type: "success",
            message: lanData.filter(
              (f) => f.lanId === "Snack_Viewed" && f.lanType === "SNACK"
            )[0].lanName,
          });
          for (let i = 0; i < data.length; i++) {
            getRowData.push({
              itemNm: data[i].itemNm,
              soNo: data[i].soNo,
              soDueDt: data[i].soDueDt
                ? Commons.DateFormating(data[i].soDueDt.toString(), 2)
                : "",
              itemUnit: data[i].itemUnit,
              remark: data[i].remark,
              stusNm: data[i].stusNm,
              delivQty: data[i].delivQty,
              // lotNo: data[i].lotNo,
            });
          }
          setRowData1(Commons.InsertNumber(getRowData));
        }
      });
    } catch (e) {
      if (e.response.status === 401) {
        setSnackbars({
          toggle: true,
          type: "error",
          message: "로그인 정보가 만료되었습니다.",
        });
      } else {
        setSnackbars({
          toggle: true,
          type: "error",
          message: e.message,
        });
      }
    } finally {
      // Dialog.ProgressBar(false);
      setProgressbar(false);
    }
  };
  const DeleteRow = async () => {
    let deleteList = [];

    deleteList = rowData2.filter((e) => e.lotNo != selectedRowData[0].lotNo);
    setRowData2(deleteList);
  };
  //바코드
  const GetBarcodeLotno = async (_lotNo) => {
    // Dialog.ProgressBar(true);
    setProgressbar(true);

    let userInfo = null;
    let getRowData = [];

    try {
      await IndexedDb.GetLoginInfo().then((result) => {
        userInfo = result;
      });
      if (
        inputs.delivOrderNo == undefined ||
        inputs.delivOrderNo == null ||
        inputs.itemCd == undefined ||
        inputs.itemCd == null
      ) {
        setSnackbars({
          toggle: true,
          type: "error",
          message: "출하지시번호 및 상세품목을 선택한 후 바코드를 찍으세요.",
        });
        return false;
      }
      for (let i = 0; i < rowData2.length; i++) {
        if (rowData2[i].lotNo === _lotNo) {
          setSnackbars({
            toggle: true,
            type: "error",
            message: "바코드중복",
          });
          return false;
        }
      }
      await Commons.Axios(
        "get",
        Global.serverUrls.useUrl +
          Global.urls.logic.Sales.SM10040.GetBarcodeLotno,
        {
          itemCd: inputs.itemCd,
          lotNo: _lotNo,
        }
      ).then((result) => {
        let data = result.data;
        if (data === "데이터가 없습니다.") {
          if (lanData.length != 0) {
            setSnackbars({
              toggle: true,
              type: "info",
              message: lanData.filter(
                (f) => f.lanId === "Snack_NullData" && f.lanType === "SNACK"
              )[0].lanName,
            });
          }
        } else if (data === "수량이 부족합니다.") {
          if (lanData.length != 0) {
            setSnackbars({
              toggle: true,
              type: "info",
              message: data,
            });
          }
        } else if (data === "품목이 다릅니다.") {
          if (lanData.length != 0) {
            setSnackbars({
              toggle: true,
              type: "info",
              message: data,
            });
          }
        } else if (data.type === "Error") {
          if (lanData.length != 0) {
            setSnackbars({
              toggle: true,
              type: "info",
              message: lanData.filter(
                (f) => f.lanId === "Snack_NullData" && f.lanType === "SNACK"
              )[0].lanName,
            });
          }
        } else if (data.length === 0) {
          if (lanData.length != 0) {
            setSnackbars({
              toggle: true,
              type: "info",
              message: lanData.filter(
                (f) => f.lanId === "Snack_NullData" && f.lanType === "SNACK"
              )[0].lanName,
            });
          }
        } else {
          setSnackbars({
            toggle: true,
            type: "success",
            message: lanData.filter(
              (f) => f.lanId === "Snack_Viewed" && f.lanType === "SNACK"
            )[0].lanName,
          });

          setRowData2([
            ...rowData2,
            {
              itemCd: data[0].itemCd,
              itemNm: data[0].itemNm,
              lotNo: data[0].lotNo,
              plantCd: data[0].plantCd,
              stockQty: data[0].stockQty,
              delivOrderQty: data[0].delivOrderQty,
              delivQty: data[0].delivQty,
            },
          ]);
          // setRowData2(Commons.InsertNumber(getRowData));
        }
      });
    } catch (e) {
      setSnackbars({
        toggle: true,
        type: "error",
        message: e.message,
      });
    } finally {
      setInputs({
        ...inputs,
        barcodeValue: "",
      });
      // setStockData([]);
      // Dialog.ProgressBar(false);
      setProgressbar(false);
    }
  };

  //출하버튼
  const CreateDeliv = async (_delivDt) => {
    // Dialog.ProgressBar(true);
    setProgressbar(true);

    let userInfo = null;
    let pushData = [];
    try {
      await IndexedDb.GetLoginInfo().then((result) => {
        userInfo = result;
      });

      for (let i = 0; i < rowData2.length; i++) {
        pushData.push({
          delivOrderNo: inputs.delivOrderNo,
          itemCd: inputs.itemCd,
          delivDt: _delivDt
            ? Commons.DateFormating(_delivDt.toString(), 2)
            : "",
          lotNo: rowData2[i].lotNo,
          delivOrderQty: inputs.delivQty,
          delivQty: rowData2[i].stockQty,
          soDueDt: inputs.soDueDt,
          soNo: inputs.soNo,
          remark: "",
          returnYn: "N",
          createId: userInfo.userId,
          createDate: Commons.DateStrChange(new Date()),
          updateId: userInfo.userId,
          updateDate: Commons.DateStrChange(new Date()),
        });
      }

      await Commons.Axios(
        "post1",
        Global.serverUrls.useUrl + Global.urls.logic.Sales.SM10040.CreateDeliv,
        pushData
      ).then((result) => {
        let data = result.data;
        if (data === "데이터가 없습니다.") {
        } else if (data.type === "Error") {
          if (lanData.length != 0) {
            throw new Error("품목 수량을 확인해주세요");
          }
        } else {
          if (lanData.length != 0) {
            setSnackbars({
              toggle: true,
              type: "info",
              message: lanData.filter(
                (f) => f.lanId === "Snack_Save" && f.lanType === "SNACK"
              )[0].lanName,
            });
          }
          setRowData2([]);
        }
      });
    } catch (e) {
      setSnackbars({
        toggle: true,
        type: "error",
        message: e.message,
      });
    } finally {
      // Dialog.ProgressBar(false);
      setProgressbar(false);
    }
  };

  const CancleBarcodeLotno = async (_lotNo) => {
    // Dialog.ProgressBar(true);
    setProgressbar(true);

    let userInfo = null;
    let getRowData = [];

    try {
      await IndexedDb.GetLoginInfo().then((result) => {
        userInfo = result;
      });
      for (let i = 0; i < rowData3.length; i++) {
        if (rowData3[i].lotNo === _lotNo) {
          setSnackbars({
            toggle: true,
            type: "error",
            message: "바코드중복",
          });
          return false;
        }
      }
      await Commons.Axios(
        "get",
        Global.serverUrls.useUrl +
          Global.urls.logic.Sales.SM10040.CancleBarcodeLotno,
        {
          itemCd: inputs.itemCd,
          lotNo: _lotNo,
        }
      ).then((result) => {
        let data = result.data;
        if (data === "데이터가 없습니다.") {
          if (lanData.length != 0) {
            setSnackbars({
              toggle: true,
              type: "info",
              message: lanData.filter(
                (f) => f.lanId === "Snack_NullData" && f.lanType === "SNACK"
              )[0].lanName,
            });
          }
        } else if (data === "수량이 부족합니다.") {
          if (lanData.length != 0) {
            setSnackbars({
              toggle: true,
              type: "info",
              message: data,
            });
          }
        } else if (data === "품목이 다릅니다.") {
          if (lanData.length != 0) {
            setSnackbars({
              toggle: true,
              type: "info",
              message: data,
            });
          }
        } else if (data.type === "Error") {
          if (lanData.length != 0) {
            setSnackbars({
              toggle: true,
              type: "info",
              message: lanData.filter(
                (f) => f.lanId === "Snack_NullData" && f.lanType === "SNACK"
              )[0].lanName,
            });
          }
        } else {
          setSnackbars({
            toggle: true,
            type: "success",
            message: lanData.filter(
              (f) => f.lanId === "Snack_Viewed" && f.lanType === "SNACK"
            )[0].lanName,
          });
          setRowData3([
            ...rowData3,
            {
              itemCd: data[0].itemCd,
              itemNm: data[0].itemNm,
              lotNo: data[0].lotNo,
              plantCd: data[0].plantCd,
              stockQty: data[0].stockQty,
              delivDt: data[0].delivDt,
              delivQty: data[0].delivQty,
              delivOrderNo: data[0].delivOrderNo,
            },
          ]);
          // setRowData2(Commons.InsertNumber(getRowData));
        }
      });
    } catch (e) {
      setSnackbars({
        toggle: true,
        type: "error",
        message: e.message,
      });
    } finally {
      setInputs({
        ...inputs,
        barcodeValue: "",
      });
      // setStockData([]);
      // Dialog.ProgressBar(false);
      setProgressbar(false);
    }
  };

  //출하취소
  const CancleDeliv = async () => {
    // Dialog.ProgressBar(true);
    setProgressbar(true);

    let pushData = [];
    let userInfo = null;
    try {
      await IndexedDb.GetLoginInfo().then((result) => {
        userInfo = result;
      });
      console.log(inputs);
      for (let i = 0; i < rowData3.length; i++) {
        pushData.push({
          delivOrderNo: inputs.delivOrderNo,
          delivNo: inputs.delivNo,
          itemCd: rowData3[i].itemCd,
          lotNo: rowData3[i].lotNo,
          delivOrderQty: inputs.delivOrderQty,
          delivQty: inputs.delivQty,
          remark: "",
          returnYn: "N",
          createId: userInfo.userId,
          createDate: Commons.DateStrChange(new Date()),
          updateId: userInfo.userId,
          updateDate: Commons.DateStrChange(new Date()),
        });
      }
      await Commons.Axios(
        "post",
        Global.serverUrls.useUrl + Global.urls.logic.Sales.SM10040.CancleDeliv,
        pushData
      ).then((result) => {
        let data = result.data;
        if (data !== "Ok") {
          setSnackbars({
            toggle: true,
            typ: "error",
            message: data,
          });
        } else {
          setSnackbars({
            toggle: true,
            type: "success",
            message: lanData.filter(
              (f) => f.lanId === "Snack_Save" && f.lanType === "SNACK"
            )[0].lanName,
          });

          setRowData3([]);
        }
      });
    } catch (e) {
      setSnackbars({
        toggle: true,
        type: "error",
        message: e.message,
      });
    } finally {
      // Dialog.ProgressBar(false);
      setProgressbar(false);
    }
  };

  return (
    <>
      {tabToggle === false ? (
        <SM10060View
          rowData={rowData}
          setRowData={setRowData}
          rowData1={rowData1}
          setRowData1={setRowData1}
          rowData2={rowData2}
          setSelectedRowData={setSelectedRowData}
          setRowData2={setRowData2}
          inputs={inputs}
          setInputs={setInputs}
          tabToggle={tabToggle}
          setTabToggle={setTabToggle}
          lanData={lanData}
          GetDelivOrderDtls={GetDelivOrderDtls}
          GetBarcodeLotno={GetBarcodeLotno}
          CreateDeliv={CreateDeliv}
          saveSoDueDt={saveSoDueDt}
          setSaveSoDueDt={setSaveSoDueDt}
          DeleteRow={DeleteRow}
          Init={Init}
        />
      ) : (
        <SM10061View
          rowData={rowData}
          setRowData={setRowData}
          rowData1={rowData1}
          setRowData1={setRowData1}
          rowData3={rowData3}
          setRowData3={setRowData3}
          inputs={inputs}
          setInputs={setInputs}
          tabToggle={tabToggle}
          setTabToggle={setTabToggle}
          lanData={lanData}
          GetDelivOrderDtls={GetDelivOrderDtls}
          GetBarcodeLotno={GetBarcodeLotno}
          CreateDeliv={CreateDeliv}
          CancleBarcodeLotno={CancleBarcodeLotno}
          CancleDeliv={CancleDeliv}
          Init={Init}
          GetSalesDelivOrderItems={GetSalesDelivOrderItems}
        />
      )}
      {snackbars.toggle && (
        <Snackbar snackbars={snackbars} setSnackbars={setSnackbars} />
      )}
      <Progressbar value={progress} />
    </>
  );
}

export default SM10060;
